import React, { useState } from "react";
import { TextModal } from "../TextModal/TextModal";
import "./CalculatorQuestions.css";
import { QuestionIcon } from "../../assets/icons";
import { useGoogleTagManager } from "@tracktor/react-google-tag-manager";
interface Question {
  key: string;
  description: string;
  question: string;
}

interface CalculatorQuestionsProps {
  questions: Question[];
  onAnswerChange?: (questionKey: string, value: string) => void;
  answers?: Record<string, number>;
}

export const CalculatorQuestions: React.FC<CalculatorQuestionsProps> = ({
  questions,
  onAnswerChange,
  answers = {},
}) => {
  const { sendEvent } = useGoogleTagManager();
  const [modalData, setModalData] = useState<{
    isVisible: boolean;
    title: string;
    description: string;
  }>({
    isVisible: false,
    title: "",
    description: "",
  });

  const handleShowDescription = (question: Question) => {
    setModalData({
      isVisible: true,
      title: `${question.key} - ${question.question}`,
      description: question.description,
    });
  };

  const handleCloseModal = () => {
    setModalData({ ...modalData, isVisible: false });
  };

  const handleAnswerSelect = (questionKey: string, value: string) => {
    if (onAnswerChange) {
      onAnswerChange(questionKey, value);
    }
  };

  const onShowDescriptionClick = (question: Question) => (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    sendEvent({
      event: "gtm.linkClick",
      linkData: {
        targetUrl: "#",
        elementId: `step_${question.key}`,
        elementClasses: ["info-button"],
        elementTarget: "modal",
      },
    });
    handleShowDescription(question);
  };

  return (
    <div className="calculator-questions">
      {questions.map((question) => (
        <div key={question.key} className="question-item">
          <div className="question-header ">
            <h3 className="question-text">
              {question.key} - {question.question}
            </h3>
            <button
              className="info-button"
              id={`step_${question.key}`}
              onClick={onShowDescriptionClick(question)}
              aria-label="Mais informações"
            >
              <QuestionIcon />
            </button>
          </div>
          <div className="answer-options">
            <label className="answer-option">
              <input
                type="radio"
                name={`question-${question.key}`}
                value="ausente"
                checked={answers[question.key] === 0}
                onChange={() => handleAnswerSelect(question.key, "ausente")}
              />
              <span className="option-text">Ausente</span>
            </label>
            <label className="answer-option">
              <input
                type="radio"
                name={`question-${question.key}`}
                value="presente"
                checked={answers[question.key] === 1}
                onChange={() => handleAnswerSelect(question.key, "presente")}
              />
              <span className="option-text">Presente</span>
            </label>
          </div>
        </div>
      ))}
      <TextModal
        title={modalData.title}
        description={modalData.description}
        isVisible={modalData.isVisible}
        onClose={handleCloseModal}
      />
    </div>
  );
};
